import { FourMp } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  logoColor,
  AllStepsBg,
  AllStepsRocketImg,
  ArrowUpRightBlue,
  GraySmily,
  CancelCircleIconRed,
  CheckCircleIconGreen,
  CheckGreen28,
  CancelredIcon,
} from "../../../../constant/imagePath";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { BeforeLoginHeader } from "../../../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import classes from "./AllSteps.module.css";
import { Button } from "../../../../stories/Button/Button";
import CongratsModal from "../../../../components/Modals/CoachFlow/OnBoarding/Congrats/Congrats";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import AllStepsMobile from "./AllStepsMobile";
import { useHistory } from "react-router-dom";
import { ReactSVG } from "react-svg";

function AllStepsDesktop() {
  const [isOpen, setIsOpen] = useState(true);
  const history = useHistory();
  const stepsData = [
    {
      stepTitle: "Step 1",
      heading: "Getting to know you",
      tagline: "Your background, experience, and expertise",
      linkText: "Start",
      onClick: () =>
        history.push({ pathname: "/on-boarding", state: { mainStep: 1 } }),
    },
    {
      stepTitle: "Step 2",
      heading: "Setting up your lesson",
      tagline: "You will be coaching 1-on-1 tennis near San Diego",
      linkText: "Start",
      isDone: false,
      onClick: () =>
        history.push({ pathname: "/on-boarding", state: { mainStep: 2 } }),
    },
    {
      stepTitle: "Step 3",
      heading: "Set your schedule",
      tagline: "Availability and pricing",
      linkText: "Start",
      isDone: true,
      onClick: () =>
        history.push({ pathname: "/on-boarding", state: { mainStep: 3 } }),
    },
  ];
  return (
    <div className={classes.allSteps}>
      <Container fluid className="p-0">
        <Row className="g-0">
          <Col xxl={3} md={4}>
            <div
              className={classes.left}
              style={{ backgroundImage: `url(${AllSteps})` }}
            >
              <img className={classes.logo} src={logoColor} />
              <h1 style={{ ...Fonts.h1, color: Colors.neutralShadesOfNero }}>
                One more Step to go!
              </h1>
              <img src={AllStepsRocketImg} className={classes.rocketImg} />
            </div>
          </Col>
          <Col xxl={9} md={8}>
            <div className={classes.right}>
              <p
                className={classes.saveAndFinishLater}
                style={{
                  ...Fonts.b2,
                  lineHeight: "20px",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Save and Finish Later
              </p>
              <Row className={` gx-0 ${classes.firstRow}`}>
                {stepsData?.map((item) => {
                  return (
                    <Col md={12}>
                      <div
                        className={classes.stepCard}
                        style={{
                          borderBottomColor: Colors.neutralShadesOfWhisper,
                        }}
                      >
                        <div className={classes.stepTitleWithIcon}>
                          <p
                            className={classes.stepTitle}
                            style={{ ...Fonts.input3, fontFamily: "inter-500" }}
                          >
                            {item?.stepTitle}
                          </p>

                          <ReactSVG
                            src={
                              item?.isDone == true
                                ? CheckGreen28
                                : CancelredIcon
                            }
                            beforeInjection={(svg) =>
                              svg.classList.add(classes.icon)
                            }
                          />
                        </div>
                        <h4 style={{ ...Fonts.h4, fontSize: "26px" }}>
                          {item?.heading}
                        </h4>
                        <p className={classes.tagline}>{item?.tagline}</p>
                        <LinkButtonWithIcon
                          primary={true}
                          text={item?.linkText}
                          rightIcon={ArrowUpRightBlue}
                          iconStyle={{ margin: "0px" }}
                          onClick={item?.onClick}
                        />
                      </div>
                    </Col>
                  );
                })}
                <Col md={12}>
                  <div className={classes.last}>
                    <Button
                      label={"Finish"}
                      primary={true}
                      size="Large"
                      customStyle={{ width: "156px" }}
                      // onClick={() => setIsOpen(true)}
                    />
                    {/* <div className={classes.bottomBox}>
                      <img src={GraySmily} />
                      <p
                        style={{
                          ...Fonts.p3,
                          color: Colors.neutralShadesOfPinkSwan,
                        }}
                      >
                        Pss.. Your progress is automatically saved
                      </p>
                    </div> */}
                  </div>
                </Col>
              </Row>
              {/*  */}
            </div>
          </Col>
        </Row>
      </Container>
      <CongratsModal show={isOpen} setShow={setIsOpen} />
    </div>
  );
}

export default function AllSteps() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <AllStepsMobile /> : <AllStepsDesktop />;
}
